import Entities from './Entities'

export default ({ getFunctions, addFunction, setWriteAccess, removeFunction }) ->
  Entities({
    addEntity: addFunction
    allEntities: -> _.filter(await Weaver.ACL.list(), '_functionACL')
    entityFilter: (value, acl) ->
      acl.id().toLowerCase().includes(value.toLowerCase())
    comparator: (fnAcl) -> fnAcl.id()
    sortBy: (fnAcl) -> fnAcl.id()
    getEntities: getFunctions
    removeEntity: removeFunction
    setWriteAccess: setWriteAccess
    title: 'permissions'
    titleRenderer: (item) -> item.id()
  })
